import React from "react";
import Request from "../../../api/Requests";

const dashboardInit = (params) => {
    
    return Request('dashboard/info', 'GET', params, true);
}




export default {
    dashboardInit
}
